import { ModalHeaderProps } from './types';

import styles from './modal-components.module.css';

export const ModalHeader = ({ children, variant = 'solid' }: ModalHeaderProps) => (
  <div className={styles.headerWrapper} data-variant={variant}>
    {children}
  </div>
);
